<template>
  <LocationMap v-if="env.VUE_APP_LOCATIONMAP === 'true' && checkSize('bigger', 768)" />
  <SearchMapModule
    v-if="env.VUE_APP_LOCATIONMAP === 'true' && checkSize('smaller', 768)"
  />
</template>
<script>
import LocationMap from "@/components/widgets/locationmap/LocationMap.vue"; // @ is an alias to /src
import SearchMapModule from "@/components/widgets/locationmap/SearchMapModule.vue"; // @ is an alias to /src
import { defineComponent } from "vue";

export default defineComponent({
  name: "LocationmapWrapper",
  components: {
    LocationMap,
    SearchMapModule,
  },
  data() {
    return {
      env: process.env,
      WinSize: 0,
      hasOffers: false,
    };
  },
  mounted() {
    this.winWidth();
    window.addEventListener("resize", this.winWidth);
  },
  methods: {
    winWidth() {
      this.WinSize = window.innerWidth;
    },
    checkSize(minmax, size) {
      const myEle = document.getElementById("crentLocationMap");
      if (!myEle) return false;
      if (minmax === "bigger" && this.WinSize >= size) {
        return true;
      }
      if (minmax === "smaller" && this.WinSize < size) {
        return true;
      }
    },
  },
});
</script>
